// extracted by mini-css-extract-plugin
export default {"root":"header-cell_root__NlVXY","special":"header-cell_special__QoY4+","specialWidth":"header-cell_specialWidth__Pj3HE","placeHolderShimmer":"header-cell_placeHolderShimmer__R6lOy"};